@if (isShort) {
  <div class="calendar-skeleton short">
    @for (col of calendarCols; track col) {
      <div class="calendar-skeleton__col" [ngClass]="{'is-glow': col === 3}">
        <div class="cell header"><div class="skeleton-block"></div></div>
        @for (row of calendarRows; track row) {
          <div class="cell"><div class="skeleton-block"></div></div>
        }
      </div>
    }
  </div>
} @else {
  <div class="calendar-skeleton">
    <div class="calendar-skeleton__nights">
      <div class="cell header"><div class="skeleton-block"></div></div>
      @for (row of calendarRows; track row) {
        <div class="cell"><div class="skeleton-block"></div></div>
      }
    </div>
    <div class="calendar-skeleton__cols">
      @for (col of calendarCols; track col) {
        <div class="calendar-skeleton__col">
          <div class="cell header"><div class="skeleton-block"></div></div>
          @for (row of calendarRows; track row) {
            <div class="cell"><div class="skeleton-block"></div></div>
          }
        </div>
      }
    </div>
  </div>
}
